import { createRouter, createWebHistory } from "vue-router";

import { authGuard } from "@/app/router/guards/auth.guard";
import { routes } from "@/app/router/routes";

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(authGuard);
